import { render } from "./PropriedadesDialog.vue?vue&type=template&id=014d13ee"
import script from "./PropriedadesDialog.vue?vue&type=script&lang=js"
export * from "./PropriedadesDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__